export default function handleCursors() {

    let allHasCursorText = document.querySelectorAll('.has-cursor-text');

    allHasCursorText.forEach((instance) => {

        let cursorText = instance.querySelector('.cursor-text');

        instance.addEventListener('mouseover', function (e) {
            let x = e.clientX;
            let y = e.clientY;
            cursorText.style.left = x + 'px';
            cursorText.style.top = y + 'px';
        });

        instance.addEventListener('mousemove', function (e) {
            let x = e.clientX;
            let y = e.clientY;
            cursorText.style.left = x + 'px';
            cursorText.style.top = y + 'px';
        });

    });

}
